import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon WarningCircleIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const WarningCircleIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 18">
      <path d="M19.76,14.87L19.76,14.87L11.85,1.03C11.47,0.38,10.77-0.02,10.01,0C9.26-0.02,8.56,0.38,8.18,1.03L0.27,14.87 c-0.36,0.65-0.36,1.44,0,2.09c0.37,0.65,1.06,1.05,1.81,1.03h15.8c1.18-0.01,2.13-0.98,2.12-2.16C20,15.5,19.91,15.17,19.76,14.87z  M10.01,15.66c-0.79,0-1.42-0.64-1.42-1.43s0.64-1.42,1.43-1.42c0.78,0,1.42,0.64,1.42,1.42C11.44,15.02,10.8,15.66,10.01,15.66 C10.01,15.66,10.01,15.66,10.01,15.66z M11.44,9.96c0,0.79-0.64,1.43-1.43,1.43c-0.79,0-1.43-0.64-1.43-1.43V5.69 c0-0.79,0.64-1.43,1.43-1.43c0.79,0,1.43,0.64,1.43,1.43V9.96z" />
    </Icon>
  )
}
export default WarningCircleIcon
